import * as React from 'react';
import { useTranslationHook } from 'PyzShopUi/scripts/utils/translationHook';
import Button from 'PyzShopUi/scripts/react/common/components/form/Button';
import {
    beginGetProductVariantLoading,
} from './actions/get-variant';
import {
    ISetPaginationPayload,
    setPagination
} from 'PyzShopUi/scripts/shop-ui/components/search-page/actions/pagination';

interface LoadMoreProps {
    currentPage: number;
    maxPage: number;
    // tslint:disable-next-line:no-any
    dispatch: React.Dispatch<any>;
    isProgressing: boolean;
}

const loadMore: React.FunctionComponent<LoadMoreProps> = props => {

    const { currentPage, maxPage, dispatch, isProgressing} = props;
    const hasNextPage = currentPage < maxPage;
    const { translate } = useTranslationHook();

    const onLoadMoreHandler = (event: Event) => {
        event.preventDefault();
        if (!hasNextPage) {
            return undefined;
        }
        dispatch(beginGetProductVariantLoading());
        const payload: ISetPaginationPayload = {
            page: (currentPage + 1).toString()
        };
        dispatch(setPagination(payload));
    };

    if (!hasNextPage) {
        return undefined;
    }

    return (
        <div>
            <Button
                label={translate('Show more variants', { ns: 'article-detail' })}
                isBordered={true}
                color={'grey'}
                icon={'arrow'}
                iconPosition={'right'}
                isDisabled={isProgressing}
                onClick={onLoadMoreHandler}
            />
        </div>
    );
};

export default loadMore;
